/**
 * The small tags a mission's card carries (10 §2): TIMED, NO DROP, POD A, NO RECALL, QUIET. Which of them a
 * mission has comes from its FACTS (archetypes.ts); what each one means comes from `describe('tag:<id>')`, as
 * the tooltip. Shared by the theatre map's node card, the briefing's mission card and the Practice picker.
 */

import type { ArchetypeId } from '../../sim/types';
import { archetypeTags } from './archetypes';
import { el } from './dom';
import type { Describe } from './text';

export function factChips(describe: Describe, archetype: ArchetypeId): HTMLElement[] {
  return archetypeTags(archetype).map(({ tag, label }) => {
    const chip = el('span', 'menu-chip menu-chip-amber menu-chip-fact', label);
    chip.title = describe(`tag:${tag}`).text;
    return chip;
  });
}
